import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import {
  Button,
  Checkbox,
  Divider,
  Grid,
  Tooltip,
  Typography,
  capitalize,
} from '@mui/material';
import React from 'react';
import { ProductProviderOptions } from '../../staticData/tableHead';

const PriceComponent = ({ product, handleBuyNow }) => {
  const providerOption = ProductProviderOptions.find(
    (option) => option.value === product.provider_name
  );
  return (
    <Grid
      item
      xs
      sx={{
        py: '14px',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: '24px',
        justifyContent: 'center',
      }}>
      <img
        src={product.icon}
        loading="lazy"
        title={product.provider_name}
        style={{
          maxHeight: '30px',
          width: '30px',
          height: 'auto',
          flexShrink: 0,
        }}
        alt={product.provider_name}
      />
      <Divider
        orientation="vertical"
        flexItem
        sx={{
          borderColor: 'black',
          opacity: 1,
        }}
      />
      <Grid container item justifyContent="flex-start" xs>
        <Typography
          variant="h6"
          sx={{
            fontSize: '18px',
            color: 'var(--Black, #000)',
            fontWeight: '400',
          }}>
          $ {parseFloat(product.price).toLocaleString('en-US', {
                maximumFractionDigits: 2,
              })} at{' '}
          {providerOption ? providerOption.label : capitalize(product.provider_name)}
        </Typography>
      </Grid>
      <Grid container item justifyContent="flex-end" xs>
        <Button
          variant="contained"
          onClick={() => handleBuyNow(product.url, product.provider_name)}
          sx={{
            borderRadius: ' 54px',
            background: 'var(--Black, #000)',
            '&:hover': {
              background: 'var(--Black, #000)',
            },
            p: 0,
          }}>
          <Typography
            sx={{
              color: 'var(--White, #FFF)',
              fontSize: '13px',
              fontWeight: 700,
              p: { sm: '10px 18px', md: '10px 24px' },
            }}>
            Buy Now
          </Typography>
        </Button>
      </Grid>
    </Grid>
  );
};

const SingleProductDesktop = ({
  product,
  handleBuyNow,
  handlePurchaseForm,
  setSelectedProduct,
  type,
  selectedProduct,
}) => {
  const isChecked = product.id === selectedProduct?.id;

  return (
    <Grid
      item
      sm
      sx={{
        pr: '30px',
        py: '30px',
        pl: type === 'purchased' ? '40px' : '80px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
      }}>
      {product.must_have && (
        <div
          style={{
            display: 'flex',
            padding: '4px 8px',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '4px',
            borderRadius: '29px',
            width: 'fit-content',
            background: 'var(--Salmon, #F5BE9F)',
          }}>
          <FavoriteBorderIcon
            sx={{
              fontSize: 16,
              color: '#000',
              fontFamily: 'Font Awesome 6 Pro',
            }}
          />
          <Typography sx={{ fontSize: 11, fontWeight: 500 }}>
            MUST HAVE
          </Typography>
        </div>
      )}

      <Typography
        variant="h6"
        sx={{
          fontSize: { sm: '24px', md: '34px' },
          fontWeight: '400',
          overflow: 'hidden',
          display: '-webkit-box',
          WebkitBoxOrient: 'vertical',
          WebkitLineClamp: 2,
          textOverflow: 'ellipsis',
        }}>
        <Tooltip title={product.product_details?.title} arrow>
          {product.product_details?.title}
        </Tooltip>
      </Typography>

      {product.product_details?.brand && (
        <Typography
          sx={{
            color: 'var(--Black, #000)',
            fontSize: ' 13px',
            fontWeight: 400,
            opacity: '0.64',
          }}>
          {product.product_details?.brand}
        </Typography>
      )}
      {product.note && (
        <Typography sx={{ fontSize: 16, mt: '8px' }}>
          <Typography variant="span" sx={{ fontWeight: 700 }}>
            Notes: &nbsp;
          </Typography>
          <Typography variant="span" sx={{ fontWeight: 400 }}>
            {product.note}
          </Typography>
        </Typography>
      )}
      {type === 'available' && (
        <Grid item xs sx={{ py: { sm: '16px', md: '20px' }, mr: '50px' }}>
          <div
            style={{
              maxHeight: '210px', 
              overflowY: 'auto', 
            }}>
            {product?.product_details?.providers?.length > 0 && (
              <Divider
                sx={{
                  borderColor: 'black',
                  opacity: 1,
                }}
              />
            )}
            {product?.product_details?.providers &&
              product.product_details.providers.map((provider, index) => (
                <React.Fragment key={index}>
                  <PriceComponent
                    product={provider}
                    handleBuyNow={handleBuyNow}
                  />
                  <Divider
                    sx={{
                      borderColor: 'black',
                      opacity: 1,
                    }}
                  />
                </React.Fragment>
              ))}
          </div>
        </Grid>
      )}
      {type === 'available' && (
        <Grid container alignItems="center">
          <Checkbox
            sx={{
              borderRadius: '4px',
              width: '16px',
              height: '16px',
              marginRight: '8px',
              '&.Mui-checked': {
                color: 'var(--Black, #000)',
              },
            }}
            checked={isChecked}
            onChange={() => setSelectedProduct(product)}
            onClick={handlePurchaseForm}
          />
          <Typography
            sx={{
              fontSize: '16px',
              fontWeight: 400,
            }}>
            I’ve purchased this
          </Typography>
        </Grid>
      )}
    </Grid>
  );
};

export default SingleProductDesktop;
